/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-console */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config, { HTTP_STATUS } from "../../config/config";
import { getCart } from "./CartSlice";

const deleteCartInitialState = {
  loading: null /* status of HTTP request */,
  data: [] /* response of HTTP request */,
};

/* handle async request and dispatch action */
export const deleteCart = createAsyncThunk(
  "tokkio/deleteCart",
  async (_, { getState, dispatch }) => {
    const state = getState();
    const currentCart = await axios(
      `${config.uiServerEndpoint}/cart/${state.uuid.sessionId}`
    );
    if(currentCart.data && currentCart.data.items && currentCart.data.items.length > 0) {
      const { data } = await axios.delete(
        `${config.uiServerEndpoint}/cart/${state.uuid.sessionId}`
      );
      dispatch(getCart());
      return data;
    }
    return null;
  }
);

/* Slice to handle DELETE request for enitre cart */
const deleteCartSlice = createSlice({
  name: "deleteCartSlice",
  initialState: deleteCartInitialState,
  reducers: {},
  extraReducers: {
    [deleteCart.pending](state) {
      state.loading = HTTP_STATUS.PENDING;
    },
    [deleteCart.fulfilled](state, { payload }) {
      state.loading = HTTP_STATUS.FULFILLED;
      state.data = payload;
    },
    [deleteCart.rejected](state) {
      state.loading = HTTP_STATUS.REJECTED;
    },
  },
});

export const deleteCartActions = deleteCartSlice.actions;
export default deleteCartSlice;
